export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/index.ts